module.exports = __webpack_public_path__ + "static/media/d_product_guide.e3102e05.png";